import { CarrierModalCustomCell } from './components/carrier-modal-custom-cell';

export const TABLE_COLUMNS_NAMES = (isLoading, isSending) => [
	{
		dataIndex: 'company',
		title: 'Компания',
		width: 220,
		render: (_, rowData) => CarrierModalCustomCell({ rowData, columnId: 'company' }),
	},
	{
		dataIndex: 'info',
		width: 30,
		align: 'center',
		render: (_, rowData) => CarrierModalCustomCell({ rowData, columnId: 'info' }),
	},
	{
		dataIndex: 'price',
		title: 'Цена без НДС',
		width: 130,
		render: (_, rowData) => CarrierModalCustomCell({ rowData, columnId: 'price' }),
	},
	{
		dataIndex: 'tax',
		title: 'НДС',
		width: 50,
		align: 'center',
		render: (_, rowData) => CarrierModalCustomCell({ rowData, columnId: 'tax' }),
	},
	{
		dataIndex: 'info_with_tax',
		width: 30,
		align: 'center',
		render: (_, rowData) => CarrierModalCustomCell({ rowData, columnId: 'info_with_tax' }),
	},
	{
		dataIndex: 'price_with_tax',
		title: 'Цена с НДС',
		width: 130,
		render: (_, rowData) => CarrierModalCustomCell({ rowData, columnId: 'price_with_tax' }),
	},
	{
		dataIndex: 'date',
		title: 'Дата доставки',
		width: 130,
		render: (_, rowData) => CarrierModalCustomCell({ rowData, columnId: 'date' }),
	},
	{
		dataIndex: 'action',
		title: '',
		width: 120,
		align: 'center',
		render: (_, rowData) => CarrierModalCustomCell({ rowData, columnId: 'action', isLoading, isSending }),
	},
];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const DATE_FORMAT = 'DD.MM.YYYY';

export const DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm:ss';
